import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import Slider from "react-slick";
import { SportQ } from '../../graphqlDic';
import { graphql, compose } from 'react-apollo';
import { Link } from 'react-router-dom';
import MoviesMediaUI from '../../components/CommonComponents/MoviesMediaUI';

class ShowItems extends Component {

    showContentMovie = dataMedias => {
        let result = [];
        if (dataMedias.length) {
            for (let indexDataType in dataMedias) {
                result.push(
                    <Link to={ '/media/watch/' + dataMedias[indexDataType].id } key={ indexDataType } >
                        <MoviesMediaUI dataMedias={ dataMedias[indexDataType] } />
                    </Link>
                );
            }
        }
        return result.length ? result : <span className="text-center">Không có medias nào trong danh sách</span>;
    }

    render() {
        if (this.props.getSportMediasByTypeCategories.loading) return "Loading...";
        if (this.props.getSportMediasByTypeCategories.error) return `Error! ${this.props.getSportMediasByTypeCategories.error.message}`;
        var sport_item = this.props.getSportMediasByTypeCategories.getSportMediasByTypeCategories;
        let settingsSlick = {
            dots: true,
            infinite: false,
            speed: 500,
            slidesToScroll: 8,
            slidesToShow: 8,
            responsive: [
                {
                    breakpoint: 1650,
                    settings: {
                        slidesToShow: 6,
                        slidesToScroll: 6,
                        dots: true
                    }
                },
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4,
                        dots: true
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                }
            ]
        };
        const Items = sport_item.map((item, i) =>
            <div key={i}>
                <div className="block-index-title text-blue">
                    <span>{item.name}</span>
                </div>
                <div className="index-movie-slick block-index-common">
                    <Slider {...settingsSlick}>
                        { this.showContentMovie(item.medias) }
                        {/* {
                            item.medias.map((media, k) =>
                                <div className="unit" key={k}>
                                    <div className="img"><img src={media.img} alt={media.name} /></div>
                                    <div className="name">
                                        <a>{media.name}</a>
                                    </div>
                                    <div className="sub-name">
                                        <img src="images/icon-play.png" alt="play-icon" />
                                        <Link to={"/media/watch/" + media.id} >{media.sub_name ? media.sub_name : media.name}</Link>
                                        <div>IMdb: <span className="point">{media.scoreImdb}</span></div>
                                        <div>Tập: {
                                            `${media.episodesCurent}/${media.episodesMax}`
                                        } </div>
                                        <div>Thể loại: {media.kind}</div>
                                        <div>Quốc gia: {media.nation}</div>
                                        <div>Ngôn ngữ: {media.languages}</div>
                                    </div>
                                </div>
                            )
                        } */}
                    </Slider>
                </div>

            </div>
        );
        return (
            <Fragment>
                {Items}
            </Fragment>
        );
    }
}
export default compose(
    graphql(SportQ, {
        name: 'getSportMediasByTypeCategories',
        options: (ownProps) => ({
            variables: {
                type: ownProps.type
            }
        })
    })
)(withRouter(
    connect(
        null
    )(ShowItems)
))




// WEBPACK FOOTER //
// ./src/containers/TVShow/ShowItems.js